import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ProjectCalculation" }
const _hoisted_2 = { class: "ProjectCalculation__main" }
const _hoisted_3 = { class: "ProjectCalculation__result" }

import { computed, PropType } from "vue";
import { Project } from "@/types";
import InnInput from "@/components/ds/input/Input.vue";
import SuggestedCalculation from "@/components/pages/project/SuggestedCalculation.vue";
import { useDocumentsStore } from "@/stores/documents";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCalculation',
  props: {
    project: {
        type: Object as PropType<Project>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const documentsStore = useDocumentsStore();

const result = computed(() => {
    return props.project.hours * props.project.rate - props.project.discount;
});

const documents = computed(() => {
    return documentsStore.list.filter(
        (doc) => doc.projectId === props.project.id && doc.doctype === "invoice"
    );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(InnInput, {
        modelValue: __props.project.hours,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.project.hours) = $event)),
        label: "Uren",
        "data-id": "hours",
        type: "number"
      }, null, 8, ["modelValue"]),
      _cache[3] || (_cache[3] = _createTextVNode(" × ")),
      _createVNode(InnInput, {
        modelValue: __props.project.rate,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.project.rate) = $event)),
        label: "Tarief",
        "data-id": "rate",
        type: "number"
      }, null, 8, ["modelValue"]),
      _cache[4] || (_cache[4] = _createTextVNode(" - ")),
      _createVNode(InnInput, {
        modelValue: __props.project.discount,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.project.discount) = $event)),
        label: "Korting",
        "data-id": "discount",
        type: "number"
      }, null, 8, ["modelValue"]),
      _cache[5] || (_cache[5] = _createTextVNode(" = ")),
      _createElementVNode("div", _hoisted_3, _toDisplayString(result.value) + " " + _toDisplayString(__props.project.currency), 1)
    ]),
    (documents.value.length > 0)
      ? (_openBlock(), _createBlock(SuggestedCalculation, {
          key: 0,
          project: __props.project,
          documents: documents.value
        }, null, 8, ["project", "documents"]))
      : _createCommentVNode("", true)
  ]))
}
}

})